// Application Insights setup and console.error interception
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";

type AppInsightsConfig = ConstructorParameters<typeof ApplicationInsights>[0];
type AppInsightsExtension = NonNullable<
  NonNullable<AppInsightsConfig["config"]>["extensions"]
>[number];

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING,
    // Align plugin type with expected extension shape when duplicate transitive core types are present.
    extensions: [reactPlugin as unknown as AppInsightsExtension],
    enableAutoRouteTracking: true,
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});
appInsights.loadAppInsights();

export default appInsights;
